import {
  actionTypes,
} from 'redux-resource';
import {
  ResourceType,
} from '../../types';

const allListPlugin = (resourceType: ResourceType) => (state, action) => {
  const includedResources = action?.includedResources || {};
  if (
    [
      actionTypes.READ_RESOURCES_SUCCEEDED,
      actionTypes.CREATE_RESOURCES_SUCCEEDED,
      actionTypes.DELETE_RESOURCES_SUCCEEDED,
    ].includes(action.type)
    && (
      action.resourceType === resourceType
      || includedResources[resourceType]
    )
  ) {
    const ids = (
      action.resourceType === resourceType
        ? (
          action.resources
        )
        : (
          includedResources[resourceType]
        )
    ).map(r => r.id || r);
    const all = (
      action.type === actionTypes.DELETE_RESOURCES_SUCCEEDED
        ? (
          (state.lists?.all || [])
            .filter(id => !ids.includes(id))
        )
        : [
          ...new Set([
            ...(state.lists?.all || []),
            ...ids,
          ]),
        ]
    );
    return {
      ...state,
      lists: {
        ...state.lists,
        all,
      },
    };
  }
  return state;
};

export default allListPlugin;
